import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setClaimPendingExternalReview = (claimId, message) =>
  call(websocketFetch, 'set_claim_pending_external_review', {
    claim_id: claimId,
    message,
  });
